class Product {

  constructor(elem) {
    this.product = elem;
    this.productSize = $('[data-product-size]');
    this.selectionsHide = $('[data-selections-hide]');
	}

  initialize() {
    $.fn.extend({
      toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
      }
    });

    this.productSize.find('button').on('click', function() {
      $(this).closest('[data-product-size]').find('button').removeClass('active');
      $(this).addClass('active');

      $('[data-btn-one-click-container]').find('[data-btn-one-click]').removeClass('d-none');
      $('[data-btn-one-click-container]').find('[data-btn-one-click-fake]').addClass('d-none');
      $('[data-btn-one-click-container]').find('[data-btn-one-click-tooltip]').addClass('d-none');
    });

    $('[data-btn-one-click-fake]').on('mouseenter', function() {
      const container = $(this).closest('[data-btn-one-click-container]');
      container.find('[data-btn-one-click-tooltip]').addClass('show');
    });

    $('[data-btn-one-click-fake]').on('mouseleave', function() {
      const container = $(this).closest('[data-btn-one-click-container]');
      container.find('[data-btn-one-click-tooltip]').removeClass('show');
    });

    $('[data-size-button]').on('click', function() {
      $(this).closest('[data-product-size]').prev().fadeOut('slow')
    })

    $('[data-size-button-uni]').on('click', function() {
      let el  = $(this);
      let index = el.parent().index() + 1;

      el.closest('[data-product-size]').parent().find('[data-product-size-uni]').children().removeClass('active');
      el.closest('[data-product-size]').parent().find('[data-product-size-uni]').children().eq(index).addClass('active')
    });

    $('[data-size-button-uni]').on('mouseover', function() {
      let el  = $(this);
      let index = el.parent().index() + 1;

      el.closest('[data-product-size]').parent().find('[data-product-size-uni]').children().removeClass('active');
      el.closest('[data-product-size]').parent().find('[data-product-size-uni]').children().eq(index).addClass('active')
    });

    $('[data-scroll-available]').on('click', function() {
      $('[data-tab-available]').trigger('click')
    });

    if (this.selectionsHide.length > 0) {
      let text = this.selectionsHide.text();

      this.selectionsHide.on('click', function(e) {
        let el = $(this);
        let parent = el.closest('[data-selections]');
        let content = parent.find('[data-selections-content]');

        el.toggleText(window.pmMessages.hide, window.pmMessages.show);
        content.slideToggle('fast')

        e.preventDefault();
      })
    }
	}
}

export {Product};

$(function () {
  window.Product = Product;
});

$(window).on('load', () => {
  let product = [];

  if ($('[data-product]').length > 0) {
		$('[data-product]').each(function(i) {
			product[i] = new Product($(this));
			product[i].initialize();
		});
	}

  var button = document.getElementById("bnplButton");
  if(button) {
    var dataValue = button.getAttribute("data-value");
    var value = Number(dataValue);

    if (value >= 6000 && value <= 200000) {
      button.style.display = "flex";
      var payment = Math.ceil(value / 4)
        .toString()
        .replace(/B(?=(d{3})+(?!d))/g, " ");
      button.innerHTML = `<div class="bnpl__wrapp_desc">${window.pmMessages.installmentTitle}</div><span class="bnpl__wrapp_price">${window.pmMessages.installmentPaymentText} ${new Intl.NumberFormat("ru-RU").format(payment)} ₸</span><svg class="icon arrow-right icon--md" aria-hidden="true"><use xlink:href="/local/frontend/build/assets/images/required/sprite.svg#arrow-right"></use></svg>`;
    } else {
      //если цена товара больше 200к то скрываем кнопку
      button.style.display = "none";
    }
  }
});
